import { formatLocalDateTime } from '@shared/vueltoDateTime';

export function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return parts[0]?.slice(0, 2).toUpperCase() ?? '??';
}

export function formatAuditWhen(iso: string): string {
  // Vacío → vacío (la UI lo usa como falsy); inválido → el propio string.
  return iso === '' ? '' : formatLocalDateTime(iso);
}
